import { BrowserRouter, Routes, Route } from 'react-router-dom';
import EditScreen from './Screens/EditScreen';
import HomeScreen from './Screens/HomeScreen';
import PrivacyScreen from './Screens/PrivacyScreen';
import TermsScreen from './Screens/TermsScreen';
import RefundScreen from './Screens/RefundScreen';
import ContactScreen from './Screens/ContactScreen';
import SignUp from './Screens/SignUp';
import SignIn from './Screens/SignIn';
import SettingsScreen from './Screens/SettingsScreen';

import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/edit" element={<EditScreen />} />
        <Route path="/settings" element={<SettingsScreen />} />
        <Route path="/privacy" element={<PrivacyScreen />} />
        <Route path="/terms" element={<TermsScreen />} />
        <Route path="/refund" element={<RefundScreen />} />
        <Route path="/contact" element={<ContactScreen />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
